/**
 * Не устарел ли пакет, который держит браузер.
 *
 * ЗАДАЧА НЕ В ТОМ, ЧТОБЫ СРАВНИТЬ ДВЕ СТРОКИ, а в том, чтобы не кричать
 * впустую. Ложная тревога здесь дороже молчания: человек, которому раз
 * за разом предлагают обновить исправную страницу, перестаёт читать
 * плашки вообще — и не прочтёт ту единственную, которая важна.
 *
 * Отсюда правило: молчим всегда, кроме случая, когда ОБЕ отметки известны
 * и различаются. Неизвестная отметка — это разработка, локальная сборка
 * или образ, собранный без переменной; ни одно из этого не повод пугать.
 *
 * ОТКУДА ВЗЯЛАСЬ ПРОВЕРКА. 09.08 сервер отвечал свежей сборкой, а в браузере
 * висел пакет, собранный до правки ставок: копейки печатались как рубли,
 * не было ни расписания, ни денег кампании. Выкатка при этом проходила
 * успешно, и понять, что смотришь на старое, было нельзя ничем.
 */

/** Отметки, по которым сравнивать нечего. */
const UNKNOWN = new Set(['', 'dev', 'unknown']);

export function isStale(webCommit: string, serverCommit: string | undefined): boolean {
  if (!serverCommit) return false;
  if (UNKNOWN.has(webCommit) || UNKNOWN.has(serverCommit)) return false;

  // Отметки могут быть разной длины: сервер отдаёт короткий хеш, а сборка
  // пакета получает тот же короткий. Сравнение по началу переживёт
  // расхождение в длине, если оно однажды появится.
  return !startsSame(webCommit, serverCommit);
}

function startsSame(a: string, b: string): boolean {
  const n = Math.min(a.length, b.length);
  return n > 0 && a.slice(0, n) === b.slice(0, n);
}

/** An API-only release does not identify the files running in the browser. */
export function servedFrontendCommit(version: { frontendCommit?: string } | undefined): string | undefined {
  return typeof version?.frontendCommit === 'string' ? version.frontendCommit : undefined;
}

/**
 * Что сказать человеку.
 *
 * ОБЫЧНОЕ ОБНОВЛЕНИЕ МОЖЕТ НЕ ПОМОЧЬ, и умолчать об этом — значит
 * отправить человека нажимать F5 по кругу. Страница могла быть сохранена
 * браузером надолго; сбрасывает такое только жёсткое обновление.
 */
export const STALE_TEXT =
  'Кабинет открыт старой сборкой: на сервере уже другая. ' +
  'Обновите страницу с очисткой — Ctrl+F5 (на маке ⌘+Shift+R).';
